import React, { FC, memo } from 'react';

import SingleFieldTab from 'components/ResqlExpert/SubmissionForm/SingleFieldTab';

const Problem: FC = () => (
  <SingleFieldTab
    fieldName="situation_description"
    titleKey="tab_situation"
    hintKey="tab_situation_hint"
  />
);

export default memo(Problem);
